export const rotaEditorDeFluxos = (flowId: string): string => `/admin-geral/flows/editor/${flowId}`;

/**
 * O editor já aberto no nó. O `flowEditor` lê `nodeId` da query, então esse nome é contrato com
 * ele. O `path` só acompanha o link do diagnóstico do agente; hoje o editor não o lê.
 *
 * @example rotaEditorDeFluxosNoNo(flowId, nodeId) // '/admin-geral/flows/editor/<flowId>?nodeId=<nodeId>'
 */
export const rotaEditorDeFluxosNoNo = (
  flowId: string,
  nodeId: string | null | undefined,
  path?: string,
): string =>
  `${rotaEditorDeFluxos(flowId)}?nodeId=${encodeURIComponent(nodeId ?? '')}` +
  (path === undefined ? '' : `&path=${encodeURIComponent(path)}`);

export const rotaEditorArbitralDeEtapas = (fluxoId: string): string =>
  `/admin-geral/secretaria/fluxos/${fluxoId}`;

const ROTA_DA_SIMULACAO_DO_ADMIN = '/admin-geral/flows/simulacao';

const comEscritorio = (rota: string, escritorioId: string | null | undefined): string =>
  escritorioId ? `${rota}?escritorioId=${encodeURIComponent(escritorioId)}` : rota;

/** A simulação completa do admin, já no escritório escolhido quando há um. */
export const rotaDaSimulacaoDoAdmin = (flowId: string, escritorioId?: string | null): string =>
  comEscritorio(`${ROTA_DA_SIMULACAO_DO_ADMIN}/${encodeURIComponent(flowId)}`, escritorioId);

/**
 * Mesmo formato do link que o core gera na superfície ADMIN (`rotaDaTelaDeAssinatura`): o
 * escritório vai na query porque o admin não tem workspace, e a tela de assinatura precisa dele
 * para achar a simulação atual.
 */
export const rotaDaAssinaturaDoAdmin = (
  flowId: string,
  assinaturaId: string,
  escritorioId: string,
): string =>
  comEscritorio(
    `${ROTA_DA_SIMULACAO_DO_ADMIN}/${encodeURIComponent(flowId)}/assinatura/${encodeURIComponent(assinaturaId)}`,
    escritorioId,
  );

/**
 * Fluxo sem `domain` ainda não carregou, e cai na simulação completa, não no sandbox: só o
 * arbitral vai para o sandbox, e só com o domínio dito (legacyCleanup.md, A3).
 * A tipagem é estrutural para `shared/` não depender do tipo de fluxo de uma feature.
 */
export const temSimulacaoCompleta = ({ domain }: { domain?: string }): boolean =>
  (domain ?? 'NEGOTIATION') === 'NEGOTIATION';

/** O teste do fluxo: a simulação completa do admin ou, fora da negociação, o sandbox antigo. */
export const rotaDeTesteDoFluxo = (fluxo: { id: string; domain?: string }): string =>
  temSimulacaoCompleta(fluxo)
    ? rotaDaSimulacaoDoAdmin(fluxo.id)
    : `${rotaEditorDeFluxos(fluxo.id)}/sandbox`;
